import axios from 'axios';

export const REST_API = 'https://hts.mobile.hyperthings.in/api/v1/';
// export const REST_API = 'http://iot.hyperthink.io:6061/api/v1/';

// axios implementation
const token = localStorage.getItem('token');
export const fetcher = axios.create({
  baseURL: REST_API,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});
// export const updateFetcher = () => {
//   const token = localStorage.getItem('token')(
//     // eslint-disable-next-line no-use-before-define
//     console.log(token);
//     (fetcher.defaults.headers.common.Authorization = `Bearer ${token}`),
//   );
// };

export const sendRequest = (url, method, body) =>
  fetcher({
    method,
    url,
    data: body,
  }).then((res) => res.data);
